import { render } from "./CheckShiftSkeleton.vue?vue&type=template&id=57d281f7"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__